<template>
  <div class="dashboard-layout-container" ref="dashboardLayoutContainer" :class="{ 'withoutBorderMode': withoutBorderMode }">
    <vuescroll :ops="ops">
      <div class="dashboard-layout-container-with-scroll" :class="{ 'scroll-mode': multiItems}">
        <div
          id='defaultLayout' 
          ref="defaultLayout">
          <div v-for="item in this.items" class="e-panel" :class="{ 'e-panel-transition e-lib ': !!settingsMode,
          'e-drag e-draggable': !!settingsMode && !resizeMode }" v-bind:key="getControlIdFromItem(item)" style="background: rgb(255, 255, 255);"
            :id= getIdFromItem(item)
            :data-row="item.row"
            :data-col="item.col" 
            :data-sizeX="item.sizeX"
            :data-sizeY="item.sizeY">
            <div class="e-panel-container">
              <div :class="{ 'snippet-container': true, 'hideScroll': settingsMode }">
                <div class="disable-click-container" v-if="settingsMode"></div>
                <dr-snippet :model="{ CurrentTemplate: getControlIdFromItem(item) }"></dr-snippet>
                <v-btn v-if="settingsMode" class="delete" icon small @click="onDeleteButtonClick" color="#212121">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vuescroll>
  </div>
</template>


<script>
import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../../assets/material.css'
import { DashboardLayoutPlugin } from '@syncfusion/ej2-vue-layouts'
import Vue from 'vue'
Vue.use(DashboardLayoutPlugin)
import { DashboardLayout } from '@syncfusion/ej2-layouts'
import { getControlIdFromItem, getIdFromItem, getCorrectIdFromModel } from '../../tools/convertItemData'
import 'intro.js/introjs.css'
import introJs from 'intro.js'
import { MainMenuApi as api } from '../../api/api.js'

export default {
  currentDashboard: undefined,
  name: 'dr-layout-main-component',
  props: ['items', 'withoutBorderMode', 'settingsMode', 'historyProps'],
  components: {
    'vuescroll': () => import('vuescroll')
  },
  data: function() {
    return {
      mediaQuery: 'max-width:100vh; max-height:100vh;',
      changesProcessed: false,
      resizeMode: false,
      ops: {
        bar: {
          background: '#aaa',
          size: '10px'
        },
        rail: {
          size: '10px'
        }
      },
      layoutChangesHistory: [],
      skipSaveHistory: false
    }
  },
  updated() {
    // При некоторых изменения dashboard метод не срабатывает
    // добавляем его исскуственный вызов
    if (this.changesProcessed) {
      this.changesProcessed = false
      return
    }
    this.onChanged()
  },
  computed: {
    multiItems() {
      return this.items.length > 1
    },
    spacing() {
      return [this.currentSpace, this.currentSpace]
    },
    currentSpace() {
      return this.multiItems ? 3 : 0
    }
  },
  created() {
    this.showHelp()
    if (this.withoutBorderMode && window.self !== window.top) {
      localStorage.setItem('startFromLauncher', true)
    }
    window.addEventListener('resize', this.onMainContainerResize)
  },
  
  destroyed() {
    window.removeEventListener('resize', this.onMainContainerResize)
    if (this.$options.dashboard) {
      this.$options.dashboard.destroy()
    }
  },
  
  mounted() {
    this.createDashboard()
  },
  methods: {
    getControlIdFromItem: getControlIdFromItem,
    
    getIdFromItem: getIdFromItem,
    
    onChanged() {
      clearTimeout(this.changesTimeout)
      this.changesProcessed = true
      let that = this
      this.changesTimeout = setTimeout(function () {
        that.createDashboard()
        that.updateLayoutFromDashboard()
      }, 30)
    },
    
    onResize() {
      this.resizeMode = false
      this.onChanged()
    },
    
    onResizeStart() {
      this.resizeMode = true
    },
    
    setCellRatio() {
      if (this.$refs && this.$refs.dashboardLayoutContainer) {
        let clientRect = this.$refs.dashboardLayoutContainer.getBoundingClientRect()
        this.$options.dashboard.cellAspectRatio = clientRect.width / clientRect.height
      }
    },
    
    onMainContainerResize() {
      if (this.$options.dashboard) {
        this.setCellRatio()
      }
    },
    
    createDashboard() {
      this.resizeMode = false
      this.$options.dashboard = new DashboardLayout({
        cellSpacing: this.spacing,
        allowResizing: !!this.settingsMode,
        allowFloating: true,
        allowDragging: !!this.settingsMode,
        resizableHandles: [ 'e-north-east', 'e-south-east', 'e-north-west', 'e-south-west' ],
        columns: 24
      })
      this.setCellRatio()
      if (this.settingsMode) {
        this.$options.dashboard.change = this.onChanged.bind(this)
        this.$options.dashboard.resizeStop = this.onResize.bind(this)
        this.$options.dashboard.resizeStart = this.onResizeStart.bind(this)
      }
      this.$options.dashboard.appendTo('#defaultLayout')
      if (this.$refs.defaultLayout) {
        this.$refs.defaultLayout.querySelectorAll('.e-dashboardlayout.e-control .e-panel .e-panel-container .e-resize.e-double').forEach(e => e.setAttribute('style', 'color: #000;'))
      }
    },
    
    updateLayoutFromDashboard() {
      let serializedDashboard = this.$options.dashboard.serialize()
      if (!this.skipSaveHistory) {
        if (this.historyProps.templatesActive) {
          this.layoutChangesHistory[this.layoutChangesHistory.length - 1] = { dashboard: serializedDashboard, isCurrent: true }
        } else {
          let isSameStep = false
          if (this.layoutChangesHistory.length > 0) {
            let lastStep = this.layoutChangesHistory[this.layoutChangesHistory.length - 1]
            lastStep.isCurrent = false
            let currentStep = this.layoutChangesHistory.find(function(el) { return el.isCurrent })
            if (currentStep) {
              let currentStepIndex = this.layoutChangesHistory.indexOf(currentStep)
              this.layoutChangesHistory = this.layoutChangesHistory.splice(0, currentStepIndex + 1)
              this.historyProps.redoDisable = true
            }
            // Если количество виджетов одинаковое, проверяем есть ли изменения хотя бы в одном
            if (lastStep.dashboard.length == serializedDashboard.length) {
              for (let i = 0; i < lastStep.dashboard.length; i++) {
                if (this.hasDifferents(lastStep.dashboard[i], serializedDashboard[i])) {
                  isSameStep = false
                  break
                } else {
                  isSameStep = true
                }
              }
            }
            // Если нету текущего шага, задаем метку последнему шагу
            if (isSameStep && !currentStep) {
              lastStep.isCurrent = true
            }
          }
          if (!isSameStep) {
            this.layoutChangesHistory.push({ dashboard: serializedDashboard, isCurrent: true })
            this.historyProps.undoDisable = this.layoutChangesHistory.length < 2
          }
        }
      }
      this.skipSaveHistory = false
      this.$emit('updateLayout', serializedDashboard)
    },

    hasDifferents(lastDashboard, currentDashboard) {
      return lastDashboard.col != currentDashboard.col
        || lastDashboard.id != currentDashboard.id
        || lastDashboard.maxSizeX != currentDashboard.maxSizeX
        || lastDashboard.maxSizeY != currentDashboard.maxSizeY
        || lastDashboard.minSizeX != currentDashboard.minSizeX
        || lastDashboard.minSizeY != currentDashboard.minSizeY
        || lastDashboard.row != currentDashboard.row
        || lastDashboard.sizeX != currentDashboard.sizeX
        || lastDashboard.sizeY != currentDashboard.sizeY
    },
    
    updatePanels: function (selected) {
      let currentControls = []
      let deletedControlId
      let newControlId
      for (let i = 0; i < this.items.length; i++) {
        let layout = this.items[i]
        let currentControlId = getControlIdFromItem(layout)
        if (selected.indexOf(currentControlId) === -1) {
          deletedControlId = currentControlId
          break
        }
        currentControls.push(currentControlId)
      }
      if (deletedControlId) {
        this.deletePanel(deletedControlId)
        return
      }
      for (let i = 0; i < selected.length; i++) {
        let currentSelected = selected[i]
        if (currentControls.indexOf(currentSelected) === -1) {
          newControlId = currentSelected
          break
        }
      }
      if (newControlId) {
        this.addPanel(newControlId)
      }
    },
    
    deletePanel(deletedControlId) {
      if (this.$refs.defaultLayout && this.$options.dashboard) {
        let id = getCorrectIdFromModel(deletedControlId)
        this.$options.dashboard.removePanel(id)
        this.updateLayoutFromDashboard()
      }
    },
    
    addPanel(controlId) {
      if (this.$refs.defaultLayout && this.$options.dashboard) {
        let id = getCorrectIdFromModel(controlId)
        let sizeXY = this.$refs.defaultLayout.children.length == 0 ? 24 : 4
        let colPosition = this.$refs.defaultLayout.children.length == 0 ? 0 : 20
        this.$options.dashboard.addPanel({ row: 0, col: colPosition, sizeY: sizeXY, sizeX: sizeXY, id: id  })
        //Исскуствено удаляем созданную панель, для избежания дублирования
        let childs = this.$refs.defaultLayout.children
        for (let i = 0; i < childs.length; i++) {
          let currentChild = childs[i]
          if (currentChild.id === id) {
            currentChild.remove()
            break
          }
        }
        this.updateLayoutFromDashboard()
      }
    },

    undoHistory: function() {
      if (this.layoutChangesHistory.length > 0) {
        let currentStep = this.layoutChangesHistory.find(function(el) { return el.isCurrent })
        if (currentStep) {
          let currentStepIndex = this.layoutChangesHistory.indexOf(currentStep)
          let newCurrentStep = this.layoutChangesHistory[currentStepIndex - 1]
          if (newCurrentStep) {
            this.skipSaveHistory = true
            currentStep.isCurrent = false
            newCurrentStep.isCurrent = true
            this.$emit('updateLayout', newCurrentStep.dashboard)
            this.historyProps.redoDisable = false
            this.historyProps.undoDisable = !this.layoutChangesHistory[currentStepIndex - 2]
          }
        }
      }
    },

    redoHistory: function() {
      if (this.layoutChangesHistory.length > 0) {
        let currentStep = this.layoutChangesHistory.find(function(el) { return el.isCurrent })
        if (currentStep) {
          let currentStepIndex = this.layoutChangesHistory.indexOf(currentStep)
          let newCurrentStep = this.layoutChangesHistory[currentStepIndex + 1]
          if (newCurrentStep) {
            this.skipSaveHistory = true
            currentStep.isCurrent = false
            newCurrentStep.isCurrent = true
            this.$emit('updateLayout', newCurrentStep.dashboard)
            this.historyProps.undoDisable = false
            this.historyProps.redoDisable = !this.layoutChangesHistory[currentStepIndex + 2]
          }
        }
      }
    },

    onDeleteButtonClick(e) {
      this.deletePanel(getControlIdFromItem(e.currentTarget.closest('.e-panel')))
    },

    async showHelp() {
      if (localStorage.getItem('mainMenuIsHelpShowed') === 'true') {
        return
      }
      let data = await api.mainMenuIsHelpShowed()
      if (!data.data.iTEnterpriseMenuQuery.mainMenuIsHelpShowed) {
        let intro = new introJs()
        intro.setOptions({
          doneLabel: this.$t('menuLayout.drLayoutMainComponen.clearly'),
          showBullets: false,
          steps: [{
            title: this.$t('menuLayout.drLayoutMainComponen.welcome'),
            intro: this.$t('menuLayout.drLayoutMainComponen.helpMessage')
          }]
        })
        intro.onexit(function () {
          api.mainMenuIsHelpShowed(true, true)
          localStorage.setItem('mainMenuIsHelpShowed', true)
        })
        this.loadStyles()
        intro.start()
      } else {
        localStorage.setItem('mainMenuIsHelpShowed', true)
      }
    },

    loadStyles(darkThemeOn) {
      let appMainMenuCacheMenu = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      let darkTheme = appMainMenuCacheMenu.data.iTEnterpriseMenuQuery?.userSettings?.darkThemeOn
      if (darkTheme != darkThemeOn) {
        if (darkTheme) {
          require('intro.js/themes/introjs-dark.css')
        } else {
          document.head.querySelectorAll('style').forEach(el => { 
            if (el.innerHTML.includes('Dark theme for IntroJs')) {
              el.remove()
            }
          })
        }
      }
      setTimeout(() => { this.loadStyles(darkTheme) }, 2000)
    }
  }
}
</script>

<style>


#defaultLayout .e-panel .e-panel-container {
  vertical-align: middle;
  overflow: auto;
}

#defaultLayout .e-panel .e-panel-container .snippet-container {
  height: 100%;
  width: 100%;
}

#defaultLayout .e-panel .e-panel-container .snippet-container.hideScroll {
  overflow: hidden;
}

.e-dashboardlayout.e-control {
  z-index: 1;
}
.e-dashboardlayout.e-control .e-panel {
  border: unset;
  box-shadow: unset;
}
.e-dashboardlayout.e-control .e-panel:hover {
  border: unset;
}
.dashboard-layout-container {
  flex-basis: 100% !important;
  display: flex;
  margin: var(--frame-padding);
  box-sizing: border-box;
  position: relative;
}
.dashboard-layout-container .e-dashboardlayout.e-control.e-responsive {
  min-height: 100% !important;
}
.dashboard-layout-container.withoutBorderMode {
  margin: 0;
}

.dashboard-layout-container .dashboard-layout-container-with-scroll.scroll-mode {
  overflow-y: auto;
  overflow-x: hidden; 
}

.dashboard-layout-container .disable-click-container {
  height: 100%;
  width: 100%;
  z-index: 8;
  position: absolute;
}

.dashboard-layout-container .e-panel:not(.e-lib) .__panel {
  height: calc(100% + 17px) !important;
}

#defaultLayout .e-panel .e-panel-container .snippet-container .delete {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 11;
  display: none;
}

#defaultLayout .e-panel .e-panel-container .snippet-container:hover .delete {
  display: flex;
}

#defaultLayout.fill-snippets {
  background: white
}

#defaultLayout.fill-snippets .e-panel {
  background: #eaeaea !important;
  border: 4px solid white;
}

#defaultLayout.fill-snippets .e-panel .e-panel-container {
  display: none;
}


.introjs-tooltip {
  min-width: 500px !important;
}

.introjs-tooltiptext {
  padding: 14px !important;
}

.introjs-skipbutton {
  display: none !important;
}

.introjs-tooltipReferenceLayer * {
  font-family: Roboto,sans-serif !important;
}

html[data-darkreader-scheme="dark"] .content-container:not(.inFrame) {
  background: #aaaaaa24 !important;
}
</style>